module.exports = __webpack_public_path__ + "static/media/quote-generator.d66a945c.png";